import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { getRegions } from '@terminal/services/geographies/geographies-service';

export const QUERY_KEY_REGIONS = 'QUERY_KEY_REGIONS';

export const createRegionsQueryOptions = () =>
  queryOptions({
    queryKey: [QUERY_KEY_REGIONS],
    queryFn: ({ signal }) => getRegions(signal),
    staleTime: getTimeTillEndOfDayMs(),
  });

export const useRegions = (enabled: boolean) =>
  useQuery({
    ...createRegionsQueryOptions(),
    enabled,
  });
